import React, {useState} from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {useForm} from "react-hook-form";

const BusRouteFilter = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id

    const [code, setCode] = useState(filter?.item?.code || null)

    const { handleSubmit } = useForm({
    });

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.code;
        }
        props.setFilter(tmpFilter);
        setCode('')
    }

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : {
                code: code
            }
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Codigo</Label>
                            <Input type="text" name="code2"
                                   placeholder="Codigo"
                                   value={code}
                                   onChange={(e) => setCode(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                        <div >
                            <ButtonSearch/>
                            <ButtonClean onClick={cleanFields}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(BusRouteFilter)